import { IGroups } from "../interfaces/iGroups";
import { IPosition } from "../interfaces/IPosition";

export class Deputies {
  constructor(
    public id:                     string,
    public name:                   string,
    public lastname:               string,
    public country:                string,
    public boardOfDirectors:       IPosition,
    public politicalParty:         string,
    public commission:             IGroups,
    public parliamentaryGroups:    IGroups[],
    public womensBlock:            IPosition,
    public exLeader:               boolean,
    public exLeaderPosition:       string,
    public image:                  string,
    public eurolat:                boolean,
    public commissionOrder:        string,
    public groupOrder:             string,
    public blockOrder:             string,
    public isActive:               boolean,
  ) { }
}
